<template>
  <div class="confirmation-modal">
    <h1>Are you sure you want to delete this profile?</h1>
    <div class="buttons">
      <button class="change-button" @click="deleteUser">{{ $t("button.yes") }}</button>
      <button class="cancel-button" @click="$emit('close-modal')">
        {{ $t("button.cancel") }}
      </button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    userId: Number,
  },
  methods: {
    async deleteUser() {
      try {
        const res = await api.deleteUser({ usr_id: this.userId });
        if(res.status == 200) {
          this.$emit('closeAndRefresh')
        }
      } catch (error) {
        this.handleError(error)
        console.log(error);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.confirmation-modal {
  h1 {
    font-size: 22px;
  }
  .buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin: 10% 0;
    & button {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      border: none;
      padding: 10px;
      border-radius: 100px;
      font-size: 16px;
      height: 40px;
      width: 70%;
    }
  }

  .change-button {
    background: var(--button-color-blue);
    color: white;
    margin-bottom: 3%;
  }
  .buttons button:active,
  .buttons button:focus {
    outline: none;
    border: none;
  }
}
</style>